import React, { useState, useEffect } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import AwpYesNoDialog from '../components/Common/AwpYesNoDialog'; // Ensure this component exists

const AwpCloseCancelButtons = ({
  props,
  onConfirmedCancel,
  onCancel,
  onSaveSuccess,
  isPristine,
  hasAccess,
  disableSave = false, // Allows external control over save button disable state
  cancelConfirmMsg = 'Are you sure you want to leave without saving changes?',
  forceShowCancelConfirm = false,
  wrapperClass = 'mt-4',
}) => {
  const [showCancelConfirm, setShowCancelConfirm] = useState(forceShowCancelConfirm);

  useEffect(() => {
    if (onCancel) onCancel(showCancelConfirm);
  }, [showCancelConfirm]);

  // Determine if the form is pristine or has changes
  const isFormPristine = isPristine;

  const handleCancel = () => {
    if (!isFormPristine) {
      if (onCancel) onCancel(true);
      setShowCancelConfirm(true);
    } else {
      props.resetForm();
      if (onConfirmedCancel) onConfirmedCancel(); // No confirmation needed for a clean form
    }
  };

  const handleSave = async () => {
    if (props.isValid && !props.isSubmitting) {
      if (onSaveSuccess) {
        await onSaveSuccess();
        return;
      }
    }
    await props.submitForm();
  };

  return (
    <div className={wrapperClass}>
      {!showCancelConfirm ? (
        <>
          <Button variant="outline-primary" onClick={handleCancel}>
            {isFormPristine ? 'Close' : 'Cancel'}
          </Button>

          {/* Save Button (Only appears when form is dirty AND user has the right permissions) */}
          {!isFormPristine && hasAccess && (
            <Button
              className="ml-2"
              type="button"
              variant="primary"
              onClick={handleSave}
              disabled={!props.isValid || props.isSubmitting || disableSave}
            >
              {props.isSubmitting ? (
                <>
                  <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
                  Saving...
                </>
              ) : (
                'Save'
              )}
            </Button>
          )}
        </>
      ) : (
        // Confirmation Dialog on Cancel with Unsaved Changes
        <AwpYesNoDialog
          action={onConfirmedCancel}
          setShowYesNoConfirm={setShowCancelConfirm}
          msg={cancelConfirmMsg}
          props={props}
        />
      )}
    </div>
  );
};

export default AwpCloseCancelButtons;
